"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardHierarchyLevelService = void 0;
var constants_1 = require("../../constants");
var StandardHierarchyLevelService = /** @class */ (function () {
    function StandardHierarchyLevelService() {
    }
    StandardHierarchyLevelService.prototype.fetchHierarchyLevelsByCurriculum = function (curriculum) {
        switch (curriculum) {
            case constants_1.CurriculumId.EurekaMath:
                return (0, constants_1.getStandardHierarchyLevelEM)();
            case constants_1.CurriculumId.EurekaMathTX:
                return (0, constants_1.getStandardHierarchyLevelEMTX)();
            default:
                return (0, constants_1.getStandardHierarchyLevelEM)();
        }
    };
    return StandardHierarchyLevelService;
}());
exports.StandardHierarchyLevelService = StandardHierarchyLevelService;
